export const EDUCATOR_PRACTICES_HEADER_TEXT = 'Educator Practices'
export const SCHOOL_HEADER_TEXT = 'School'
export const SCHOOLWIDE_PRACTICES_HEADER_TEXT = 'Schoolwide Practices'
export const STUDENT_ACTIVITIES_HEADER_TEXT = 'Student Activities'
